module.exports = __webpack_public_path__ + "img/dd2_scheme.14c74d75.svg";